/** Driver shtati bo'yicha vaqt zonasi: qo'ng'iroq va eslatma driver vaqtida kelishiladi, recruiter o'z vaqtida ko'radi. */

export const STATE_TZ: Record<string, string> = {
  CT: "America/New_York", DE: "America/New_York", FL: "America/New_York", GA: "America/New_York", ME: "America/New_York",
  MD: "America/New_York", MA: "America/New_York", NH: "America/New_York", NJ: "America/New_York", NY: "America/New_York",
  NC: "America/New_York", OH: "America/New_York", PA: "America/New_York", RI: "America/New_York", SC: "America/New_York",
  VT: "America/New_York", VA: "America/New_York", WV: "America/New_York", DC: "America/New_York", MI: "America/New_York",
  IN: "America/New_York", KY: "America/New_York",
  AL: "America/Chicago", AR: "America/Chicago", IL: "America/Chicago", IA: "America/Chicago", KS: "America/Chicago",
  LA: "America/Chicago", MN: "America/Chicago", MS: "America/Chicago", MO: "America/Chicago", NE: "America/Chicago",
  ND: "America/Chicago", OK: "America/Chicago", SD: "America/Chicago", TN: "America/Chicago", TX: "America/Chicago",
  WI: "America/Chicago",
  AZ: "America/Phoenix", CO: "America/Denver", ID: "America/Denver", MT: "America/Denver", NM: "America/Denver",
  UT: "America/Denver", WY: "America/Denver",
  CA: "America/Los_Angeles", NV: "America/Los_Angeles", OR: "America/Los_Angeles", WA: "America/Los_Angeles",
  AK: "America/Anchorage", HI: "Pacific/Honolulu",
};

export const driverTz = (state: string) => STATE_TZ[state] ?? "America/Chicago";

/** "CST", "EDT" kabi qisqa nom; brauzer bilmasa -- zona nomi */
export function tzAbbr(tz: string, date: Date): string {
  try {
    return new Intl.DateTimeFormat("en-US", { timeZone: tz, timeZoneName: "short" }).formatToParts(date).find((p) => p.type === "timeZoneName")?.value ?? tz;
  } catch {
    return tz;
  }
}

/** Qo'ng'iroq vaqti, driverning mahalliy soatida: [boshlanish, tugash) -- taxmin (08-build-log, 2026-10-11) */
export const CALL_HOURS: readonly [number, number] = [9, 20];

const hourFormat = new Map<string, Intl.DateTimeFormat>();

function hourMinute(date: Date, tz: string): number {
  let f = hourFormat.get(tz);
  if (!f) {
    f = new Intl.DateTimeFormat("en-US", { timeZone: tz, hourCycle: "h23", hour: "numeric", minute: "numeric" });
    hourFormat.set(tz, f);
  }
  const parts = Object.fromEntries(f.formatToParts(date).map((p) => [p.type, p.value]));
  return (Number(parts.hour) % 24) * 60 + Number(parts.minute);
}

/**
 * Hozir driverga qo'ng'iroq qilsa bo'ladimi: ochiq bo'lsa -- tugashiga, yopiq bo'lsa -- ochilishiga necha daqiqa.
 * Yozgi vaqt o'tadigan tunda bir soatga adashishi mumkin (qo'ng'iroq vaqtidan tashqarida, ahamiyatsiz).
 */
export function callWindow(now: Date, tz: string, hours: readonly [number, number] = CALL_HOURS): { open: boolean; minutes: number } {
  const m = hourMinute(now, tz);
  const start = hours[0] * 60;
  const end = hours[1] * 60;
  if (m >= start && m < end) return { open: true, minutes: end - m };
  return { open: false, minutes: m < start ? start - m : 24 * 60 - m + start };
}
